// extracted by mini-css-extract-plugin
export default {"editedLabel":"styles_editedLabel__HNdAD","editIcon":"styles_editIcon__H9Jx7","dotBadge":"styles_dotBadge__Su0VF"};